<template>
  <div
    v-if="site"
    class="container"
  >
    <Toolbar class="mt-2 mb-2">
      <template #start>
        <h2>{{ $t('nav.siteDetail') }}</h2>
      </template>

      <template #end>
        <Button
          :label="$t('action.back')"
          icon="pi pi-arrow-left"
          class="p-button-secondary p-button-rounded p-button-outlined"
          @click="toSiteTable"
        />
      </template>
    </Toolbar>

    <Panel>
      <template #header>
        <p class="font-bold">
          {{ $t('sitedetailpage.fieldset.site') }}
        </p>
      </template>
      <div class="card_details">
        <div class="card_body">
          <ul class="flex justify-content-between">
            <li>
              <ul>
                <li>{{ $t('entity.site.code') }} : <strong>{{ site.code }}</strong></li>
                <li>{{ $t('entity.site.phone_number') }} : <strong>{{ formatPhoneNumberAsInternational(site.phoneNumber, site.phoneNumberCountryCode) }}</strong></li>
                <li>{{ $t('entity.site.cluster') }} : <strong>{{ site.cluster }}</strong></li>
                <li>{{ $t('entity.site.french_description') }} :</li>
                <li><strong class="description">{{ site.frenchDescription }}</strong></li>
              </ul>
            </li>
            <li>
              <ul>
                <li>{{ $t('entity.site.name') }} : <strong>{{ site.name }}</strong></li>
                <li>{{ $t('entity.site.timezone') }} : <strong>{{ site.timezone }}</strong></li>
                <li>{{ $t('entity.site.enabled') }} :
                  <strong>{{ site.enabled ? $t('entity.site.enabled') : $t('entity.site.disabled') }}</strong></li>
                <li>{{ $t('entity.site.english_description') }} :</li>
                <li><strong class="description">{{ site.englishDescription }}</strong></li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </Panel>

    <Panel class="mt-3 mb-3">
      <template #header>
        <p class="font-bold">
          {{ $t('sitedetailpage.fieldset.address') }}
        </p>
      </template>
      <div class="card_details">
        <div class="card_body">
          <ul class="flex justify-content-between">
            <li>
              <ul>
                <li>{{ $t('entity.site.address.name') }} : <strong>{{ site.address.name }}</strong></li>
                <li>{{ $t('entity.site.address.city') }} : <strong>{{ site.address.city }}</strong></li>
              </ul>
            </li>
            <li>
              <ul>
                <li>{{ $t('entity.site.address.postcode') }} : <strong>{{ site.address.postcode }}</strong></li>
                <li>{{ $t('entity.site.address.country') }} : <strong>{{ site.address.country }}</strong></li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </Panel>
  </div>
</template>

<script>
import Panel from "primevue/panel";
import Toolbar from "primevue/toolbar";
import Button from "primevue/button";
import {formatPhoneNumberAsInternational} from "@/shared/utils/phoneNumberUtils";

export default {
  name: 'SiteDetail',
  components: {Panel, Toolbar, Button},
  data() {
    return {
      site: null
    }
  },
  async mounted() {
    try {
      this.site = await this.$siteService.fetchById(this.$route.params.id);
      if (!this.site) await this.$router.push("/site");
    } catch (error) {
      this.$emitter.emit('toast', {
        severity: 'error',
        message: error.response.data.map(error => this.$t(error)).join(', ')
      });
      await this.$router.push("/site");
    }
  },
  methods: {
    formatPhoneNumberAsInternational,
    toSiteTable() {
      this.$router.push({ name: 'site' })
    }
  }
}
</script>

<style lang="scss" scoped>
span {
  float: right;
}

.card_details {
  span {
    float: none;
  }

  ul,
  ol {
    list-style: none;
    padding: 0;
  }

  .card_header {
    .card_times {
      background: #f7f7f7;
      padding: 10px;
      font-weight: 600;
    }
  }

  .card_body {
    li {
      width: 25vw;
      padding: 5px 0;
    }

  }
}

.description {
  white-space: pre-line;
  text-align: justify;
  word-break: break-word;
}

::v-deep(div.p-panel-header) {
  padding: 0 1rem;
}

::v-deep(div.p-panel-content) {
  padding: 0.1rem 1rem;
}
</style>
